import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { validateLoginChange } from 'models/persons'

@form({
  form: 'form-change-person-login',
  validate: validateLoginChange
})
class PersonLoginChange extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    changePersonLogin: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.props.changePersonLogin)}>
        <div>
          <Input name="email" intlKey="label.email" />
          <Input name="emailRepeat" intlKey="label.repeat_email" />
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.close"
              secondary
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.set" isLoading={submitting}>
              Set
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default PersonLoginChange
